<mat-dialog-content>


    <div class="images" fxFlex fxLayout="row wrap" fxLayoutAlign="center start" fxLayoutGap="20px" >
        <div>
            <mat-progress-bar mode="buffer" *ngIf="!image_inside_back"></mat-progress-bar>
            <img class="image-zoom" [src]="image_inside_back"  (click)="showImage(image_inside_back)">
            <p>Inside Back</p>
        </div>
        <div>
            <mat-progress-bar mode="buffer" *ngIf="!image_inside_front"></mat-progress-bar>
            <img class="image-zoom" [src]="image_inside_front"  (click)="showImage(image_inside_front)">
            <p>Inside Front</p>
        </div>
        <div>
            <mat-progress-bar mode="buffer" *ngIf="!image_outside_back"></mat-progress-bar>
            <img class="image-zoom" [src]="image_outside_back"  (click)="showImage(image_outside_back)">
            <p>Outside Back</p>
        </div>
        <div>
            <mat-progress-bar mode="buffer" *ngIf="!image_outside_front"></mat-progress-bar>
            <img class="image-zoom" [src]="image_outside_front"  (click)="showImage(image_outside_front)">
            <p>Outside Front</p>
        </div>
        <div>
            <mat-progress-bar mode="buffer" *ngIf="!image_outside_left"></mat-progress-bar>
            <img class="image-zoom" [src]="image_outside_left"  (click)="showImage(image_outside_left)">
            <p>Outside Right</p>
        </div>
        <div>
            <mat-progress-bar mode="buffer" *ngIf="!image_outside_right"></mat-progress-bar>
            <img class="image-zoom" [src]="image_outside_right"  (click)="showImage(image_outside_right)">
            <p>Outside Left</p>
        </div>

    </div>
</mat-dialog-content>







